import { defineComponent } from 'vue';
export default defineComponent({
    name: 'LabelForm',
    props: {
        label: String,
        description: String,
        required: Boolean,
        withoutNewline: Boolean,
        prop: String,
        rules: Array
    }
});
